export default function (state = {}, action) {
    switch (action.type) {
        case "SET_SETTINGS":
            return action.settingsToRetrieve;
        default:
            return state;
    }
}